export default "__VITE_ASSET__C0tyhn_F__"